import { Link } from "@tanstack/react-router"
import { cn } from "@/lib/utils"
import { layoutContainerClassName } from "./constants"

export type FooterLink = { label: string } & (
  { to: string; href?: never } | { href: string; to?: never }
)

/** Desktop footer links; the phone layout shows them on Account instead.
 *  `to` is an in-app route, `href` an external URL. */
export const FOOTER_LINKS: FooterLink[] = [
  { label: "Contact", to: "/contact" },
  { label: "Blog", href: "https://blog.yomimono.ai" },
  { label: "Privacy", href: "https://yomimono.ai/privacy.html" },
  { label: "Terms", href: "https://yomimono.ai/terms.html" },
]

export const Footer = () => (
  <footer className="border-t bg-background">
    <div className={cn(layoutContainerClassName, "py-12")}>
      <div className="flex flex-col items-center justify-between gap-4 text-sm text-muted-foreground sm:flex-row sm:items-start">
        <p>© 2026 yomimono. All rights reserved.</p>
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 sm:justify-end">
          {FOOTER_LINKS.map((link) =>
            link.to ? (
              <Link
                key={link.label}
                to={link.to}
                className="hover:text-foreground"
              >
                {link.label}
              </Link>
            ) : (
              <a
                key={link.label}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-foreground"
              >
                {link.label}
              </a>
            )
          )}
        </div>
      </div>
    </div>
  </footer>
)
